import React, { Component } from 'react'
import { any, bool } from 'prop-types'
import Icon from '../components/Icon'
import cx from 'classnames'

import './Loading.css'

class Loading extends Component {
  static propTypes = {
    className: any,
    children: any,
    forceShow: bool,
    error: bool,
    pastDelay: bool,
    timedOut: bool
  }

  static defaultProps = {
    className: ''
  }

  render () {
    const {
      error,
      pastDelay,
      timedOut,
      className,
      children,
      forceShow
    } = this.props
    const show = forceShow || error || pastDelay || timedOut
    const alertClasses = cx('loading-alert__container', {
      'alert--error': error,
      'alert--warning': timedOut,
      'alert--info': forceShow || pastDelay
    })
    const iconClasses = cx('cell-align--center', {
      'animate--spin': !error
    })
    const containerClasses = cx(
      'container--small flex-container--center',
      className
    )
    const fallbackContent = error ? 'Unavailable' : 'Please wait'
    const iconName = error ? 'close' : 'gear'

    if (show) {
      return (
        <div className={containerClasses}>
          <div className={alertClasses}>
            <Icon iconName={iconName} className={iconClasses} />{' '}
            {children || fallbackContent}
          </div>
        </div>
      )
    }

    return null
  }
}

export default Loading
